var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-tags-input',{attrs:{"tags":_vm.value,"autocomplete-items":_vm.autocompleteItems,"add-only-from-autocomplete":true},on:{"tags-changed":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }